import React from "react";

export const TermsOfService = () => (
  <div className="legal-content">
    <div className="legal-section">
      <h3>제1조 (목적)</h3>
      <p>본 약관은 SamFlow(이하 "회사")가 제공하는 실시간 수업 상호작용 플랫폼 'ClassLive'(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자 간의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
    </div>

    <div className="legal-section">
      <h3>제2조 (용어의 정의)</h3>
      <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
      <ul>
        <li>"서비스": 회사가 운영하는 ClassLive 웹 애플리케이션 및 관련 부가 서비스를 의미합니다.</li>
        <li>"교사(호스트)": 서비스를 통해 '교실(Room)'을 생성하고 수업 환경을 주도적으로 관리하는 권한을 가진 이용자를 의미합니다.</li>
        <li>"학생(참여자)": 교사가 생성한 교실 코드나 링크를 통해 접속하여 질문, 채팅, 설문 등에 참여하는 이용자를 의미합니다.</li>
        <li>"교실(Room)": 실시간 상호작용이 일어나는 가상의 공간을 의미합니다.</li>
        <li>"휘발성 데이터": 서비스 이용 과정에서 생성되어 영구 저장되지 않고 일정 시간 후 파기되는 모든 활동 기록을 의미합니다.</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>제3조 (약관의 효력 및 변경)</h3>
      <ol>
        <li>본 약관은 회사가 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</li>
        <li>회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
        <li>약관을 개정할 경우 회사는 적용 일자 및 개정 사유를 명시하여 서비스 초기 화면에 그 적용 일자 7일 전부터 공지합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제4조 (서비스 이용 및 관리)</h3>
      <ol>
        <li>서비스는 별도의 회원가입 없이 익명으로 이용하거나, 교사의 설정에 따라 실명으로 이용할 수 있습니다.</li>
        <li>회사는 수업 운영의 편의를 위해 질문, 채팅, 설문, 도구(타이머 등) 기능을 제공합니다.</li>
      </ol>
    </div>

    <div className="legal-section highlight">
      <h3>제5조 (데이터의 보유 및 파기)</h3>
      <ol>
        <li><strong>자동 파기 원칙:</strong> 본 서비스의 모든 교실 데이터 및 활동 기록은 생성 시점으로부터 **24시간이 경과하면 서버에서 자동으로 영구 삭제**됩니다.</li>
        <li><strong>교사의 즉시 삭제권:</strong> 교사는 '교실 삭제' 기능을 통해 수업 종료 시 즉시 모든 데이터를 파기할 수 있는 권한과 책임이 있습니다.</li>
        <li><strong>복구 불가:</strong> 파기된 데이터는 어떠한 경우에도 복구가 불가능하며, 이용자는 파기 전 필요한 자료를 직접 보관(스크린샷 등)해야 합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제6조 (이용자의 의무)</h3>
      <ol>
        <li>이용자는 수업 목적 외의 부적절한 언행(욕설, 비속어, 성희롱 등)을 하여서는 안 됩니다.</li>
        <li>타인의 명예를 훼손하거나 지식재산권을 침해하는 행위를 금지합니다.</li>
        <li>공공질서 및 미풍양속에 반하는 정보를 유포하는 행위를 금지합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제7조 (교사(호스트)의 의무 및 권한)</h3>
      <ol>
        <li>교사는 자신이 개설한 교실의 관리자로서 학생들의 활동을 모니터링하고 관리할 책임이 있습니다.</li>
        <li>교사는 실명 모드 사용 시 학생(또는 법정대리인)으로부터 개인정보 수집 및 이용에 대한 별도의 동의를 얻어야 합니다.</li>
        <li>교사는 수업 종료 시 데이터를 즉시 삭제하거나 24시간 후 자동 파기됨을 학생들에게 사전에 안내해야 합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제8조 (지식재산권)</h3>
      <ol>
        <li>이용자가 서비스 내에 게시한 게시물의 저작권은 해당 게시자에게 귀속됩니다.</li>
        <li>회사는 서비스 운영, 홍보 및 개선 목적 범위 내에서 이용자의 게시물을 이용할 수 있습니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제9조 (회사의 의무 및 보안)</h3>
      <ol>
        <li>회사는 지속적이고 안정적인 서비스 제공을 위해 최선을 다합니다.</li>
        <li>회사는 이용자의 개인정보 및 데이터를 안전하게 처리하기 위해 현대적인 보안 기술(SSL 통신 암호화, RLS 등)을 적용합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제10조 (서비스 제한 및 중단)</h3>
      <p>회사는 다음의 경우 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.</p>
      <ul>
        <li>천재지변 또는 불가항력적 국가 비상사태의 경우</li>
        <li>서버 점검, 교체 또는 고장으로 인한 보수 시</li>
        <li>기타 서비스 운영상 상당한 이유가 있는 경우</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>제11조 (면책 사항)</h3>
      <ol>
        <li>회사는 무료 서비스 이용과 관련하여 이용자에게 발생한 손해에 대하여 책임을 지지 않습니다.</li>
        <li>회사는 이용자 간에 발생한 분쟁에 대해 개입하거나 책임을 지지 않습니다.</li>
        <li>자동 파기 정책에 의해 손실된 데이터에 대한 책임은 이용자에게 있습니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>제12조 (서비스 중단 및 재입장)</h3>
      <p>이용자는 교실 퇴장 기능을 통해 언제든지 서비스 이용을 중단할 수 있으며, 재입장 시에는 기존 참여 기록이 유지되지 않을 수 있습니다.</p>
    </div>

    <div className="legal-section">
      <h3>제13조 (준거법 및 관할)</h3>
      <p>본 약관과 관련하여 회사와 이용자 간에 발생한 분쟁에 대해서는 대한민국 법령을 적용하며, 회사의 소재지를 관할하는 법원을 전용 관할 법원으로 합니다.</p>
    </div>
  </div>
);

export const PrivacyPolicy = () => (
  <div className="legal-content">
    <div className="legal-section">
      <h3>1. 14세 미만 아동의 개인정보 보호</h3>
      <ol>
        <li><strong>가입 없는 코드 접속:</strong> 본 서비스는 만 14세 미만 아동이 직접 계정을 생성하는 회원가입 절차를 운영하지 않습니다. 아동은 교사가 발급한 '입장 코드' 또는 초대 링크를 통해서만 실시간 수업(교실)에 참여할 수 있습니다.</li>
        <li><strong>최소 수집 및 가명 참여 원칙:</strong> 회사는 아동으로부터 이메일, 전화번호, 주소 등 개인을 직접 식별할 수 있는 정보를 요구하지 않습니다. 아동은 서비스 이용 시 실명 대신 '닉네임'을 사용하는 가명 참여를 기본 원칙으로 권장합니다.</li>
        <li><strong>교사(호스트)의 관리 책임:</strong> 교육적 목적을 위해 교사가 학생의 실명 사용을 설정한 경우, 해당 개인정보 처리에 대한 법정대리인의 동의 수합 권한과 책임은 교사 및 소속 교육기관에 있습니다. 회사는 교사가 입력하거나 학생이 입력한 실명 정보를 기술적으로 저장 및 표시하는 매개체 역할만을 수행합니다.</li>
        <li><strong>휘발성 데이터 관리:</strong> 실명 참여 시 업로드되는 이름 정보는 수업 운영을 위한 휘발성 데이터로서 생성 24시간 후 자동 파기되며, 회사는 이를 식별 정보로 영구 저장하거나 다른 목적으로 활용하지 않습니다.</li>
        <li><strong>권리 행사:</strong> 법정대리인은 언제든지 해당 아동의 개인정보에 대한 열람, 정정 및 파기를 교사 또는 회사에 요청할 수 있습니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>2. 수집하는 개인정보 항목 및 수집 방법</h3>
      <p>회사는 서비스 제공에 꼭 필요한 최소한의 개인정보만 수집하며, 수집하는 항목과 방법은 다음과 같습니다.</p>
      <ol>
        <li><strong>익명 모드 이용 시:</strong> 별도의 실명 정보를 수집하지 않으며, 이용자가 설정한 닉네임만을 수업 내 식별을 위해 활용합니다.</li>
        <li><strong>닉네임 모드 이용 시:</strong> 이용자가 입력한 항목을 수집하나 실명 사용을 권장하지 않습니다.</li>
        <li><strong>교사(호스트):</strong> 이메일 주소(통합 인증 시), 성함(실명으로 학급 생성 시).</li>
        <li><strong>자동 수집 항목:</strong> 접속 로그, IP 주소, 기기 정보(OS, 브라우저 유형).</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>3. 수집 및 이용 목적</h3>
      <p>회사는 다음의 목적을 위해 최소한의 개인정보를 수집 및 이용합니다.</p>
      <ul>
        <li>실시간 수업 참여 및 실시간 피드백 기능 제공</li>
        <li>이용자 식별 및 서비스 남용 방지</li>
        <li>서비스 오류 해결 및 성능 개선</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>4. 개인정보의 제3자 제공 및 위탁 (외부 서비스 공시)</h3>
      <p>서비스의 안정적인 제공을 위해 다음과 같이 개인정보 처리를 위탁하고 있습니다.</p>
      <table className="legal-table">
        <thead>
          <tr>
            <th>수탁자</th>
            <th>위탁 업무</th>
            <th>전송 항목</th>
            <th>보유 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Supabase (PostgreSQL)</td>
            <td>데이터 보관 및 처리 시스템 제공</td>
            <td>닉네임, 이용 기록, 접속 로그</td>
            <td>24시간 후 자동 파기</td>
          </tr>
          <tr>
            <td>Cloudflare</td>
            <td>웹 서비스 호스팅 및 인프라 관리</td>
            <td>접속 서버 로그(IP 등)</td>
            <td>서비스 로그 보존 기간</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="legal-section highlight">
      <h3>5. 보유 및 이용 기간 (휘발성 데이터 원칙)</h3>
      <p>ClassLive는 개인정보 유출 위험을 원천 차단하기 위해 '휘발성 데이터 관리' 정책을 시행합니다.</p>
      <ul>
        <li><strong>24시간 자동 파기:</strong> 생성된 모든 데이터는 생성 시점으로부터 24시간 후 영구 삭제됩니다.</li>
        <li><strong>수동 파기:</strong> 교사(호스트)가 교실을 삭제할 경우 즉시 데이터가 파기됩니다.</li>
        <li><strong>퇴장 시 파기:</strong> 학생이 교실에서 퇴장할 경우 관련 세션 정보는 지체 없이 무효화됩니다.</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>6. 파기 절차 및 방법</h3>
      <p>회사는 데이터 보유 기간이 종료된 시점에 복구가 불가능한 기술적 방법(데이터베이스 레코드 영구 삭제 등)을 사용하여 정보를 즉시 파기합니다.</p>
    </div>

    <div className="legal-section">
      <h3>7. 정보주체와 법정대리인의 권리·의무 및 그 행사 방법</h3>
      <ol>
        <li>정보주체(또는 법정대리인)는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 및 동의 철회 요구 등의 권리를 행사할 수 있습니다.</li>
        <li><strong>행사 방법 및 절차:</strong>
          <ul>
            <li>개인정보 보호책임자에게 전자우편(E-mail)을 통해 요청</li>
          </ul>
        </li>
        <li>회사는 권리 행사를 요청받은 날로부터 10일 이내에 해당 요청에 대한 조치 결과를 회신하겠습니다. 단, 자동 파기 정책(24시간 경과 혹은 교사가 직접 교실 삭제)에 따라 이미 파기된 데이터는 열람 또는 제공이 불가능할 수 있습니다.</li>
        <li>권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 「개인정보 처리 방법에 관한 고시」 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</li>
        <li>개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.</li>
        <li>개인정보의 삭제는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>8. 안전성 확보를 위한 기술적/관리적 조치</h3>
      <ol>
        <li><strong>데이터 격리:</strong> Row Level Security(RLS) 기술을 적용하여 다른 교실 간의 데이터 접근을 엄격히 차단합니다.</li>
        <li><strong>암호화 통신:</strong> 전 구간 SSL/TLS 보안 프로토콜을 적용하여 데이터 전송 시 유출을 방지합니다.</li>
        <li><strong>보안 로그:</strong> 비인가 접근에 대한 실시간 모니터링을 수행합니다.</li>
      </ol>
    </div>

    <div className="legal-section">
      <h3>9. 쿠키 및 자동 수집 장치</h3>
      <p>서비스 이용 편의를 위해 '로컬 스토리지(Local Storage)' 또는 '세션' 기술을 사용하여 일부 정보를 임시 저장할 수 있습니다. 이는 웹 브라우저 설정을 통해 거부할 수 있습니다.</p>
    </div>

    <div className="legal-section">
      <h3>10. 개인정보 보호책임자 및 상담 창구</h3>
      <p>개인정보 처리 업무를 총괄하고 정보주체의 불만 처리와 피해 구제를 위해 아래와 같이 개인정보 보호책임자를 두고 있습니다.</p>
      <ul>
        <li>개인정보 보호책임자: 이창민 (SsamFlow 운영자)</li>
        <li>연락처: <a href="mailto:contact@ssamflow.com">contact@ssamflow.com</a></li>
        <li>상담 가능 시간: 평일 09:00 ~ 18:00</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>11. 권익침해 구제 수단</h3>
      <p>개인정보 침해에 대한 신고나 상담이 필요한 경우 아래 기관에 문의하시기 바랍니다.</p>
      <ul>
        <li>개인정보 침해신고센터 (privacy.kisa.or.kr / 국번 없이 118)</li>
        <li>대검찰청 사이버수사과 (www.spo.go.kr / 국번 없이 1301)</li>
        <li>경찰청 사이버수사국 (ecrm.police.go.kr / 국번 없이 182)</li>
      </ul>
    </div>

    <div className="legal-section">
      <h3>12. 교사(호스트)의 개인정보 관리 가이드라인</h3>
      <ol>
        <li>실명 사용이 필요한 경우 교육부 지침 및 학교 규칙에 근거한 동의 여부를 반드시 확인하십시오.</li>
        <li>익명 닉네임 사용을 권장하여 학생들의 개인정보 노출을 최소화하십시오.</li>
        <li>수업 종료 후에는 데이터를 즉시 파기하여 불필요한 정보 보유를 방지하십시오.</li>
      </ol>
    </div>
  </div>
);
